import { apiClient } from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { tokenService } from "../utils/tokenService";

import {
  ApiResponse,
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from "../types";

export interface OnboardingStatusResponse {
  accountTypeCompleted: boolean;
  treatmentCompleted: boolean;
  businessInfoCompleted: boolean;
  serviceAreaAndLocationCompleted: boolean;
  subscriptionCompleted: boolean;
  onboardingStatus: "IN_PROGRESS" | "SUBMITTED";
}

/**
 * Heavy-duty cleanup helper (Private to this module)
 */
async function performHardLogout() {
  // 1. Use the Master Wipe from tokenService
  tokenService.clearAllData();

  // 2. Clear Browser Cache (Service Workers)
  if ("caches" in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }

  // 3. Hard Redirect
  window.location.href = "/";
}

export const authService = {
  sendOtp: (
    data: SendOtpRequest
  ): Promise<SendOtpResponse> => {
    return apiClient(ENDPOINTS.AUTH.SEND_OTP, {
      method: "POST",
      body: data,
      skipAuth: true,
    });
  },

  verifyOtp: (data: VerifyOtpRequest): Promise<ApiResponse<VerifyOtpResponse>> => {
    return apiClient(ENDPOINTS.AUTH.VERIFY_OTP, {
      method: "POST",
      body: data,
      skipAuth: true,
    });
  },

  logout: async (): Promise<void> => {
    try {
      const refreshToken = tokenService.getRefreshToken();
      await apiClient(ENDPOINTS.AUTH.LOGOUT, {
        method: "POST",
        body: { refreshToken },
      });
    } catch (error) {
      console.warn("Logout API call failed, cleaning locally:", error);
    } finally {
      await performHardLogout();
    }
  },


  getOnboardingStatus: (): Promise<ApiResponse<OnboardingStatusResponse>> => {
    return apiClient('/v1/partner/web/onboarding-status', {
      method: "GET",
    });
  },
};